export default __webpack_public_path__ + "static/media/DOM-FEB2025.62b87c18.png";